var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12V12.6C10 13.2365 9.78929 13.847 9.41421 14.2971C9.03914 14.7471 8.53043 15 8 15C7.46957 15 6.96086 14.7471 6.58579 14.2971C6.21071 13.847 6 13.2365 6 12.6V12M13.8482 10.9337C12.9735 9.90476 12.3559 9.38095 12.3559 6.5442C12.3559 3.94643 10.9757 3.02092 9.83976 2.57143C9.68886 2.51185 9.54682 2.375 9.50084 2.22604C9.30158 1.57423 8.74296 1 8.00041 1C7.25785 1 6.6989 1.57455 6.50168 2.2267C6.45569 2.37729 6.31366 2.51185 6.16276 2.57143C5.02543 3.02158 3.6466 3.94381 3.6466 6.5442C3.6449 9.38095 3.02735 9.90476 2.15264 10.9337C1.79022 11.36 2.10768 12 2.74157 12H13.2626C13.8931 12 14.2086 11.358 13.8482 10.9337Z",
    stroke: "#8F8E99",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.aa1f42ab680f5db737e626195de5a104.svg";
export { ForwardRef as ReactComponent };